import { useContext, useEffect, useState } from 'react';
import { distinctUntilChanged, map, tap } from 'rxjs';

import { RxFormContext } from '../Context';

/**
 * A simple counter for the amount of current errors
 */
export function useErrorCount(): number {
    const { getErrorStream } = useContext(RxFormContext);
    const [state, setState] = useState(0);
    useEffect(() => {
        const sub = getErrorStream()
            .pipe(
                map((errors) => {
                    return Object.keys(errors).length;
                }),
                distinctUntilChanged(),
                tap(setState),
            )
            .subscribe();
        return () => sub.unsubscribe();
    }, [getErrorStream]);
    return state;
}
